import { writable } from "svelte/store";
import { STATES_MAIN, STATES_LANDING } from "./states";
import MapViewService from "../services/MapViewService";
const initialState = {
    tncAcccepted: false,
    config: {
        clientId: "",
        clientSecret: "",
        webMapId: "",
        tncUrl: "",
        welcomeText: ""
    },
    token: "",
    tourStep: 0,
    currentState: `${STATES_MAIN.LANDING}.${STATES_LANDING.AUTHENTICATING_APP}`,
    mapViewService: new MapViewService(),
    riskProfile: undefined,
    searchResults: [],
    splashHide: false,
    selectedLocation: undefined,
    selectedLikelihood: undefined
};
export default writable(initialState);
